import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { useSensors, useSensor, DndContext, closestCenter, DragOverlay, TouchSensor, MouseSensor } from '../../node_modules/@dnd-kit/core/dist/core.esm.js';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DefaultItemWrapper } from './DefaultItemWrapper.js';
import { SortableItem } from './SortableItem.js';
import styles from './SortableList.module.scss.js';

function SortableList(_ref) {
  var sortableItems = _ref.sortableItems,
    sortDone = _ref.sortDone,
    dataTestId = _ref.dataTestId,
    gaTracking = _ref.gaTracking,
    disabled = _ref.disabled,
    ItemWrapper = _ref.ItemWrapper;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeId = _useState2[0],
    setActiveId = _useState2[1];
  var _useState3 = useState(sortableItems),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    newIndex = _useState6[0],
    setNewIndex = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    oldIndex = _useState8[0],
    setOldIndex = _useState8[1];
  var sensors = useSensors(useSensor(MouseSensor, {
    activationConstraint: {}
  }), useSensor(TouchSensor, {
    activationConstraint: {}
  }));
  function handleDragStart(event) {
    setActiveId(event.active.id);
  }
  function handleDragEnd(event) {
    setActiveId(null);
    var active = event.active,
      over = event.over;
    if (active.id !== over.id) {
      setItems(function (currentItems) {
        var currentOldIndex = currentItems.indexOf(active.id);
        var currentNewIndex = currentItems.indexOf(over.id);
        setNewIndex(currentNewIndex);
        setOldIndex(currentOldIndex);
        return arrayMove(currentItems, currentOldIndex, currentNewIndex);
      });
    }
  }
  useEffect(function () {
    if (oldIndex !== undefined && newIndex !== undefined) {
      sortDone(oldIndex, newIndex);
    }
  }, [newIndex, oldIndex]);
  useEffect(function () {
    if (gaTracking) {
      gaTracking('view');
    }
  }, [gaTracking]);
  if (disabled) {
    return /*#__PURE__*/React.createElement("ul", {
      className: classNames(styles.disabledContainer)
    }, items.map(function (element, index) {
      return /*#__PURE__*/React.createElement(ItemWrapper, {
        key: "item-".concat(index),
        isDraggable: false
      }, element);
    }));
  }
  return /*#__PURE__*/React.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: closestCenter,
    onDragEnd: handleDragEnd,
    onDragStart: handleDragStart
  }, /*#__PURE__*/React.createElement(SortableContext, {
    items: items,
    strategy: verticalListSortingStrategy
  }, /*#__PURE__*/React.createElement("ul", {
    className: classNames(styles.draggableContainer),
    id: dataTestId
  }, items.map(function (id) {
    return /*#__PURE__*/React.createElement(SortableItem, {
      key: id,
      id: id,
      value: id
    }, /*#__PURE__*/React.createElement(ItemWrapper, null, id));
  }))), /*#__PURE__*/React.createElement(DragOverlay, null, activeId ? /*#__PURE__*/React.createElement(ItemWrapper, null, activeId) : null));
}
SortableList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  sortableItems: PropTypes.array,
  sortDone: PropTypes.func,
  dataTestId: PropTypes.string,
  gaTracking: PropTypes.func,
  disabled: PropTypes.bool,
  ItemWrapper: PropTypes.node
};
SortableList.defaultProps = {
  sortableItems: [],
  dataTestId: '',
  disabled: false,
  gaTracking: function gaTracking() {},
  sortDone: function sortDone() {},
  ItemWrapper: DefaultItemWrapper
};

export { SortableList as default };
